// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name, dir = "icons/navbar") => (
  <SvgIconStyle
    src={`/static/${dir}/${name}.svg`}
    sx={{ width: 22, height: 22 }}
  />
);

const ICONS = {
  page: getIcon('ic_page'),
  dashboard: getIcon('ic_analytics'),
  map: getIcon('ic_map'),
  ecommerce: getIcon('ic_ecommerce'),
  elements: getIcon('ic_elements'),
  code: getIcon('ic_code', 'icons'),
  list: getIcon('list_unordered', 'icons/editor'),
  user: getIcon('ic_user'),
  energy: getIcon('ic_firebase', 'icons'),
  beer: getIcon('beer-mug', 'icons'),
  wastewater: getIcon('tap-on', 'icons'),
  error: getIcon('ic_error', 'icons/navbar'),
  status: getIcon('settings', 'icons/controls'),
  dev: getIcon('ic_code', 'icons'),
  settings: getIcon('settings', 'icons/controls'),
  dash: getIcon('list_unordered', 'icons/editor'),
  wifi: getIcon('wifi', 'icons'),
  assistant: getIcon('microchip-solid-full', 'icons'),
  export: getIcon('ic_charts'),
  // ERP module icons
  erpProductTypes: getIcon('product-types', 'icons/erp'),
  erpProcessFlows: getIcon('process-flows', 'icons/erp'),
  erpIngredients: getIcon('ingredients', 'icons/erp'),
  erpRecipes: getIcon('recipes', 'icons/erp'),
  erpProduction: getIcon('production', 'icons/erp'),
  erpPackaging: getIcon('packaging', 'icons/erp'),
  erpInventory: getIcon('inventory', 'icons/erp'),
  erpBarrels: getIcon('barrels', 'icons/erp'),
  erpOrders: getIcon('orders', 'icons/erp'),
  erpCustomers: getIcon('customers', 'icons/erp'),
  erpPicking: getIcon('picking', 'icons/erp'),
  erpShipping: getIcon('shipping', 'icons/erp'),
  erpPurchases: getIcon('purchases', 'icons/erp'),
  erpScheduling: getIcon('scheduling', 'icons/erp'),
  erpIntegrations: getIcon('ic_code', 'icons'),
  erpSkus: getIcon('skus', 'icons/erp'),
  erpExcise: getIcon('excise', 'icons/erp'),
  erpSuppliers: getIcon('suppliers', 'icons/erp'),
  erpDashboard: getIcon('dashboard', 'icons/erp'),
  erpSettings: getIcon('settings', 'icons/controls')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    /* subheader: 'general', */
    items: [
      {
        title: 'Dashboard',
        href: PATH_DASHBOARD.general.dashboard,
        icon: ICONS.elements,
        auth: false
      },
      {
        title: 'ERP',
        href: PATH_DASHBOARD.erp.root,
        icon: ICONS.ecommerce,
        info: (
          <span
            style={{
              border: '1px solid rgba(46, 196, 141, 0.55)',
              borderRadius: 999,
              color: '#2ec48d',
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: 0,
              lineHeight: 1,
              marginLeft: 8,
              padding: '3px 7px',
              textTransform: 'uppercase'
            }}
          >
            alpha
          </span>
        ),
        items: [
          { title: 'ERP Dashboard', href: PATH_DASHBOARD.erp.dashboard, icon: ICONS.erpDashboard },
          { title: 'Product Types', href: PATH_DASHBOARD.erp.productTypes, feature: 'product_types', roles: ['production'], icon: ICONS.erpProductTypes },
          { title: 'Process Flows', href: PATH_DASHBOARD.erp.processFlows, feature: 'process_flows', roles: ['production'], icon: ICONS.erpProcessFlows },
          { title: 'Ingredients', href: PATH_DASHBOARD.erp.ingredients, feature: 'ingredients', roles: ['production'], icon: ICONS.erpIngredients },
          { title: 'Recipes', href: PATH_DASHBOARD.erp.recipes, feature: 'recipes', roles: ['production'], icon: ICONS.erpRecipes },
          { title: 'Production', href: PATH_DASHBOARD.erp.production, feature: 'batches', roles: ['production'], icon: ICONS.erpProduction },
          { title: 'Packaging', href: PATH_DASHBOARD.erp.packaging, feature: 'packaging', roles: ['packaging'], icon: ICONS.erpPackaging },
          { title: 'SKUs', href: PATH_DASHBOARD.erp.skus, feature: 'skus', roles: ['packaging'], icon: ICONS.erpSkus },
          { title: 'Scheduler', href: PATH_DASHBOARD.erp.scheduling, feature: 'tank_scheduling', roles: ['production'], icon: ICONS.erpScheduling },
          { title: 'Barrels', href: PATH_DASHBOARD.erp.barrels, feature: 'barrels', roles: ['production'], icon: ICONS.erpBarrels },
          { title: 'Customers', href: PATH_DASHBOARD.erp.customers, feature: 'crm', roles: ['sales', 'accounting'], icon: ICONS.erpCustomers },
          { title: 'Sales Orders', href: PATH_DASHBOARD.erp.orders, feature: 'orders', roles: ['sales', 'accounting', 'warehouse'], icon: ICONS.erpOrders },
          { title: 'Picking', href: PATH_DASHBOARD.erp.picking, feature: 'picking', roles: ['warehouse'], icon: ICONS.erpPicking },
          { title: 'Shipping', href: PATH_DASHBOARD.erp.shipping, feature: 'shipping', roles: ['warehouse'], icon: ICONS.erpShipping },
          { title: 'Excise and Compliance', href: PATH_DASHBOARD.erp.excise, feature: 'excise', roles: ['accounting'], icon: ICONS.erpExcise },
          { title: 'Suppliers', href: PATH_DASHBOARD.erp.suppliers, feature: 'suppliers', roles: ['warehouse'], icon: ICONS.erpSuppliers },
          { title: 'Inventory', href: PATH_DASHBOARD.erp.inventory, feature: 'inventory', roles: ['warehouse'], icon: ICONS.erpInventory },
          { title: 'Purchases', href: PATH_DASHBOARD.erp.purchases, feature: 'purchases', roles: ['warehouse'], icon: ICONS.erpPurchases },
          { title: 'Integrations', href: PATH_DASHBOARD.erp.integrations, feature: 'accounts_integration', roles: ['accounting'], icon: ICONS.erpIntegrations },
          { title: 'User Guide', href: PATH_DASHBOARD.erp.userGuide, icon: ICONS.page },
          { title: 'Settings', href: PATH_DASHBOARD.erp.settings, icon: ICONS.erpSettings, roles: ['admin'] }
        ]
      },
      {
        title: 'Scout Chat',
        href: PATH_DASHBOARD.general.assistant,
        icon: ICONS.assistant,
        info: (
          <span
            style={{
              border: '1px solid rgba(46, 196, 141, 0.55)',
              borderRadius: 999,
              color: '#2ec48d',
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: 0,
              lineHeight: 1,
              marginLeft: 8,
              padding: '3px 7px',
              textTransform: 'uppercase'
            }}
          >
            beta
          </span>
        )
      },
      {
        title: 'Site Map',
        href: PATH_DASHBOARD.general.sitemap,
        icon: ICONS.map
      },
      {
        title: 'Energy',
        href: PATH_DASHBOARD.general.energy,
        icon: ICONS.dashboard
      },
      {
        title: 'Plant Insights',
        href: PATH_DASHBOARD.general.plantInsights,
        icon: ICONS.assistant
      },
      // {
      //   title: 'Waste Water',
      //   href: PATH_DASHBOARD.general.wastewater,
      //   icon: ICONS.wastewater
      // },
      {
        title: 'Batches',
        href: PATH_DASHBOARD.general.batches,
        icon: ICONS.beer
      },
      {
        title: 'Templates',
        href: PATH_DASHBOARD.general.templates,
        icon: ICONS.elements
      },
      {
        title: 'Logs',
        href: PATH_DASHBOARD.general.logs,
        icon: ICONS.error
      },

      {
        title: 'Integrations',
        href: PATH_DASHBOARD.general.integrations,
        icon: ICONS.dev
      },
      {
        title: 'Account',
        href: PATH_DASHBOARD.general.account,
        icon: ICONS.user
      },
      {
        title: 'Developer',
        href: PATH_DASHBOARD.general.developer,
        icon: ICONS.dev
      },
      {
        title: 'Configuration',
        href: PATH_DASHBOARD.general.configuration,
        icon: ICONS.settings
      },
      {
        title: 'Network',
        href: PATH_DASHBOARD.general.network,
        icon: ICONS.wifi
      },
      {
        title: 'Data Export',
        href: PATH_DASHBOARD.general.export,
        icon: ICONS.export
      },
      {
        title: 'User guide',
        href: PATH_DASHBOARD.general.docs,
        icon: ICONS.page
      },
      {
        title: 'Changelog',
        href: PATH_DASHBOARD.general.changelog,
        icon: ICONS.dash
      },
      {
        title: 'Frigid Site Overview',
        href: PATH_DASHBOARD.general.admin,
        icon: ICONS.dash
      },
      {
        title: 'Maintenance',
        href: PATH_DASHBOARD.general.status,
        icon: ICONS.status
      },
    ]
  },

  // APP
  // ----------------------------------------------------------------------
  /* {
    subheader: 'app',
    items: [
      {
        title: 'Drop',
        href: PATH_DASHBOARD.app.root,
        icon: ICONS.dashboard,
        items: [
          {
            title: 'page Four',
            href: PATH_DASHBOARD.app.pageFour
          },
          {
            title: 'Page Five',
            href: PATH_DASHBOARD.app.pageFive
          },
          {
            title: 'Page Six',
            href: PATH_DASHBOARD.app.pageSix
          }
        ]
      }
    ]
  } */
];

export default sidebarConfig;
